export default __webpack_public_path__ + "static/neuchatel-map-a492599a6ca5405ddcc8c272e48059f4.png";